var React = require('react');

function CheckboxFilled (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","rx":"2","fill":"black","key":0}),React.createElement("path",{"d":"M4.5 10.7893L8.44767 14L16.5 6","stroke":"white","strokeWidth":"1.2","strokeLinejoin":"round","key":1})]);
}

CheckboxFilled.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheckboxFilled;

CheckboxFilled.default = CheckboxFilled;
